import * as React from "react";
import { 
  Users, UserPlus, Shield, ArrowLeft, Trash2, Clock, Activity,
  Loader2, Search, Mail, CheckCircle, XCircle, Crown, User as UserIcon,
  BarChart3, RefreshCw, AlertCircle, Filter, Eye, X, Database, 
  Settings, Plug, ChevronRight, ToggleLeft, Lock, Send, Ban, ShieldCheck, Trash2 as Trash2Icon, MoreHorizontal
} from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import axios from "axios";
import { toast } from "sonner";
import { DatabricksSettings } from "@/components/DatabricksSettings";
import { LakebaseSettings } from "@/components/LakebaseSettings";
import { FivetranStatusCard } from "@/components/FivetranStatusCard";
import { SmtpSettings } from "@/components/SmtpSettings";
import { AnthropicSettings } from "@/components/AnthropicSettings";
import { AnomalyV2Admin } from "@/components/AnomalyV2Admin";
import { PercentileV2Admin } from "@/components/PercentileV2Admin";
import { AdminDashboardAnalytics } from "@/components/AdminDashboardAnalytics";
import { DataPulseAdmin } from "@/components/DataPulseAdmin";
import { ModuleControl } from "@/components/ModuleControl";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

const formatDateLong = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("es-ES", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
};

const getActionLabel = (action) => {
  const labels = {
    login: "Inicio de sesión",
    logout: "Cierre de sesión",
    create_alert: "Creación de alerta",
    run_analysis: "Ejecución de análisis",
    invite_user: "Invitación de usuario",
    remove_user: "Eliminación de usuario",
    update_role: "Actualización de rol",
    update_user_status: "Cambio de estado de usuario",
    delete_user: "Eliminación de usuario",
    update_databricks_credentials: "Actualización de Databricks",
    update_lakebase_credentials: "Actualización de Lakebase",
    update_smtp_credentials: "Actualización de SMTP",
    toggle_smtp: "Cambio estado SMTP",
    resend_invitation: "Reenvío de invitación",
    update_anthropic_key: "Actualización key Claude",
    run_baseline_job: "Ejecución baseline anomalías",
    run_detection_job: "Ejecución detección anomalías",
    run_pct_baseline_job: "Ejecución baseline percentiles",
    run_pct_analysis_job: "Ejecución análisis percentiles",
    create_team: "Creación de equipo",
    update_team: "Edición de equipo",
    delete_team: "Eliminación de equipo",
    view_module: "Acceso a módulo",
    select_client: "Selección de cliente",
    view: "Vista de módulo",
    query: "Consulta",
    export: "Exportación",
    create: "Creación",
    edit: "Edición",
    delete: "Eliminación"
  };
  return labels[action] || action;
};

const getModuleLabel = (module) => {
  const labels = {
    auth: "Autenticación",
    admin: "Administración",
    country_sentinel: "Country Sentinel",
    anomaly_detection: "Anomalías v1",
    anomaly: "Anomalías v1",
    anomaly_v2: "Anomalías v2",
    percentile_analysis: "Percentiles v1",
    percentiles: "Percentiles v1",
    percentile_v2: "Percentiles v2",
    qa: "QA de Anuncios",
    qa_validation: "QA de Anuncios",
    workload: "Carga de Trabajo",
    master_dashboard: "Master Dashboard",
    campaign_performance: "Campaign Performance",
    budget_utilization: "Budget Utilization",
    campaign_structure: "Campaign Structure",
    media_planner: "Media Planner",
  };
  return labels[module] || module;
};

const getModuleColor = (module) => {
  const colors = {
    auth: "bg-slate-200 text-slate-700",
    admin: "bg-purple-100 text-purple-700",
    country_sentinel: "bg-cyan-100 text-cyan-700",
    anomaly_detection: "bg-pink-100 text-pink-700",
    anomaly: "bg-pink-100 text-pink-700",
    anomaly_v2: "bg-orange-100 text-orange-700",
    percentile_analysis: "bg-amber-100 text-amber-700",
    percentiles: "bg-amber-100 text-amber-700",
    percentile_v2: "bg-cyan-100 text-cyan-700",
    qa: "bg-emerald-100 text-emerald-700",
    qa_validation: "bg-emerald-100 text-emerald-700",
    workload: "bg-orange-100 text-orange-700",
    master_dashboard: "bg-amber-100 text-amber-700",
    campaign_performance: "bg-blue-100 text-blue-700",
    budget_utilization: "bg-emerald-100 text-emerald-700",
    campaign_structure: "bg-indigo-100 text-indigo-700",
    media_planner: "bg-violet-100 text-violet-700",
  };
  return colors[module] || "bg-slate-100 text-slate-700";
};

const getActionIcon = (action) => {
  const icons = {
    login: "🔑",
    logout: "🚪",
    view_module: "📱",
    select_client: "🏢",
    view: "👁",
    query: "🔍",
    export: "📥",
    create: "➕",
    edit: "✏️",
    delete: "🗑",
    invite_user: "📧",
    remove_user: "❌",
    update_role: "👤",
    update_user_status: "🔒",
    delete_user: "🗑",
    run_analysis: "📊",
    create_alert: "🔔",
    update_databricks_credentials: "🔐",
    update_lakebase_credentials: "🔐",
    update_smtp_credentials: "📧",
    update_anthropic_key: "🤖",
    toggle_smtp: "📧",
    resend_invitation: "📨",
    run_baseline_job: "⚙️",
    run_detection_job: "⚙️",
    run_pct_baseline_job: "⚙️",
    run_pct_analysis_job: "⚙️",
    create_team: "👥",
    update_team: "👥",
    delete_team: "👥",
  };
  return icons[action] || "📝";
};

// Generate human-readable description when details is empty
const getAutoDescription = (log) => {
  if (log.details && Object.keys(log.details).length > 0) {
    return Object.entries(log.details).map(([k, v]) => {
      const val = typeof v === 'object' ? JSON.stringify(v) : String(v);
      return `${k.replace(/_/g, ' ')}: ${val}`;
    }).join(", ");
  }
  const moduleLabel = getModuleLabel(log.module);
  const descriptions = {
    view_module: `Accedió a ${moduleLabel}`,
    select_client: `Seleccionó cliente en ${moduleLabel}`,
    login: `Inició sesión`,
    logout: `Cerró sesión`,
    run_analysis: `Ejecutó análisis en ${moduleLabel}`,
    create_alert: `Creó alerta en ${moduleLabel}`,
    invite_user: `Invitó usuario`,
    remove_user: `Eliminó usuario`,
    update_role: `Actualizó rol de usuario`,
    run_baseline_job: `Ejecutó cálculo de baseline`,
    run_detection_job: `Ejecutó detección de anomalías`,
    run_pct_baseline_job: `Ejecutó baseline de percentiles`,
    run_pct_analysis_job: `Ejecutó análisis de percentiles`,
    create_team: `Creó equipo en ${moduleLabel}`,
    update_team: `Editó equipo en ${moduleLabel}`,
    delete_team: `Eliminó equipo en ${moduleLabel}`,
    resend_invitation: `Reenvió invitación`,
    update_databricks_credentials: `Actualizó credenciales Databricks`,
    update_lakebase_credentials: `Actualizó credenciales Lakebase`,
    update_smtp_credentials: `Actualizó configuración SMTP`,
    update_anthropic_key: `Actualizó API key de Claude`,
    toggle_smtp: `Cambió estado de SMTP`,
  };
  return descriptions[log.action] || `${getActionLabel(log.action)} en ${moduleLabel}`;
};

// Helper to format detail values (handles nested objects)
const formatDetailValue = (value) => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "object") {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
};

// Activity Log Detail Modal
const ActivityLogDetailModal = ({ log, open, onClose }) => {
  if (!log) return null;
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="text-2xl">{getActionIcon(log.action)}</span>
            {getActionLabel(log.action)}
          </DialogTitle>
          <DialogDescription>
            Detalles completos de la actividad registrada
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4 overflow-y-auto flex-1">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-xs text-slate-500">Usuario</Label>
              <p className="font-medium">{log.user_email}</p>
            </div>
            <div>
              <Label className="text-xs text-slate-500">Módulo</Label>
              <Badge className={getModuleColor(log.module)}>
                {getModuleLabel(log.module)}
              </Badge>
            </div>
            <div>
              <Label className="text-xs text-slate-500">Fecha y hora</Label>
              <p className="text-sm">{formatDateLong(log.timestamp)}</p>
            </div>
            <div>
              <Label className="text-xs text-slate-500">Dirección IP</Label>
              <p className="text-sm font-mono">{log.ip_address || "No disponible"}</p>
            </div>
          </div>
          
          {log.details && Object.keys(log.details).length > 0 && (
            <div className="border-t pt-4">
              <Label className="text-xs text-slate-500 mb-2 block">Detalles de la acción</Label>
              <div className="bg-slate-50 rounded-lg p-4 space-y-2 max-h-[300px] overflow-y-auto">
                {Object.entries(log.details).map(([key, value]) => (
                  <div key={key} className="flex flex-col gap-1">
                    <span className="text-xs text-slate-500 capitalize">{key.replace(/_/g, " ")}:</span>
                    {typeof value === "object" ? (
                      <pre className="text-xs font-mono bg-white p-2 rounded border overflow-x-auto">
                        {JSON.stringify(value, null, 2)}
                      </pre>
                    ) : (
                      <span className="text-sm font-medium">{String(value)}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="border-t pt-4">
            <Label className="text-xs text-slate-500 mb-2 block">ID del registro</Label>
            <code className="text-xs bg-slate-100 px-2 py-1 rounded">{log.id}</code>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onClose(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// Filter Bar Component
const FilterBar = ({ searchValue, onSearchChange, placeholder, children }) => (
  <div className="flex flex-wrap items-center gap-3 mb-4 p-3 bg-slate-50 rounded-lg">
    <div className="flex items-center gap-2 flex-1 min-w-[200px]">
      <Search className="h-4 w-4 text-slate-400" />
      <Input
        placeholder={placeholder || "Buscar..."}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        className="h-9 bg-white"
      />
    </div>
    {children}
    {searchValue && (
      <Button variant="ghost" size="sm" onClick={() => onSearchChange("")} className="h-9">
        <X className="h-4 w-4 mr-1" />
        Limpiar
      </Button>
    )}
  </div>
);

// Sidebar Navigation Item
const SidebarItem = ({ icon: Icon, label, active, onClick, badge, disabled, disabledIcon: DisabledIcon }) => (
  <button
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all text-left ${
      disabled 
        ? "opacity-50 cursor-not-allowed bg-slate-50 text-slate-400"
        : active 
          ? "bg-gradient-to-r from-purple-500 to-indigo-500 text-white shadow-md" 
          : "text-slate-600 hover:bg-slate-100"
    }`}
  >
    {disabled && DisabledIcon ? (
      <DisabledIcon className="h-5 w-5 text-slate-400" />
    ) : (
      <Icon className={`h-5 w-5 ${active ? "text-white" : "text-slate-500"}`} />
    )}
    <span className="font-medium flex-1">{label}</span>
    {disabled ? (
      <Badge className="bg-slate-200 text-slate-500 text-[10px]">Inactivo</Badge>
    ) : badge ? (
      <Badge className={active ? "bg-white/20 text-white" : "bg-slate-200 text-slate-600"}>
        {badge}
      </Badge>
    ) : null}
    <ChevronRight className={`h-4 w-4 ${disabled ? "text-slate-300" : active ? "text-white/70" : "text-slate-400"}`} />
  </button>
);

export const AdminPanel = ({ onBack, currentUser }) => {
  // Main section: "users" or "integrations"
  const [activeSection, setActiveSection] = React.useState("overview");
  const [activeTab, setActiveTab] = React.useState("dashboard");
  
  // System config for module control
  const [systemConfig, setSystemConfig] = React.useState({
    notifications_enabled: true,
    marketing_enabled: true,
    operations_enabled: true,
    fivetran_enabled: true
  });
  
  const [stats, setStats] = React.useState(null);
  const [users, setUsers] = React.useState([]);
  const [authorizedEmails, setAuthorizedEmails] = React.useState([]);
  const [activityLogs, setActivityLogs] = React.useState([]);
  const [activityTotal, setActivityTotal] = React.useState(0);
  const [activityHasMore, setActivityHasMore] = React.useState(false);
  const [loadingMoreLogs, setLoadingMoreLogs] = React.useState(false);
  const [accessHistory, setAccessHistory] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  
  // Filters
  const [userSearch, setUserSearch] = React.useState("");
  const [userRoleFilter, setUserRoleFilter] = React.useState("all");
  const [authSearch, setAuthSearch] = React.useState("");
  const [authStatusFilter, setAuthStatusFilter] = React.useState("all");
  const [accessSearch, setAccessSearch] = React.useState("");
  const [accessActionFilter, setAccessActionFilter] = React.useState("all");
  const [logSearch, setLogSearch] = React.useState("");
  const [logModuleFilter, setLogModuleFilter] = React.useState("all");
  const [logActionFilter, setLogActionFilter] = React.useState("all");
  
  // Invite dialog
  const [showInviteDialog, setShowInviteDialog] = React.useState(false);
  const [inviteEmail, setInviteEmail] = React.useState("");
  const [inviteRole, setInviteRole] = React.useState("user");
  const [isInviting, setIsInviting] = React.useState(false);
  
  // Activity log detail
  const [selectedLog, setSelectedLog] = React.useState(null);
  const [showLogDetail, setShowLogDetail] = React.useState(false);

  React.useEffect(() => {
    loadData();
    loadSystemConfig();
    
    // Listen for system config updates from ModuleControl
    const handleConfigUpdate = (event) => {
      setSystemConfig(event.detail);
    };
    window.addEventListener('systemConfigUpdated', handleConfigUpdate);
    return () => window.removeEventListener('systemConfigUpdated', handleConfigUpdate);
  }, []);

  const loadSystemConfig = async () => {
    try {
      const response = await axios.get(`${API}/system-config/public`);
      setSystemConfig(response.data);
    } catch (error) {
      console.error("Error loading system config:", error);
    }
  };

  const loadData = async () => {
    setIsLoading(true);
    try {
      const [statsRes, usersRes, emailsRes, logsRes, accessRes] = await Promise.all([
        axios.get(`${API}/admin/stats`, { withCredentials: true }),
        axios.get(`${API}/admin/users`, { withCredentials: true }),
        axios.get(`${API}/admin/authorized-emails`, { withCredentials: true }),
        axios.get(`${API}/admin/activity-logs?limit=50&skip=0`, { withCredentials: true }),
        axios.get(`${API}/admin/access-history?limit=100`, { withCredentials: true })
      ]);
      
      setStats(statsRes.data);
      setUsers(usersRes.data);
      setAuthorizedEmails(emailsRes.data);
      const logData = logsRes.data;
      setActivityLogs(logData.logs || []);
      setActivityTotal(logData.total || 0);
      setActivityHasMore(logData.has_more || false);
      setAccessHistory(accessRes.data);
    } catch (error) {
      console.error("Error loading admin data:", error);
      toast.error("Error al cargar datos de administración");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInvite = async (emailToInvite = null, roleToAssign = null) => {
    const email = emailToInvite || inviteEmail.trim().toLowerCase();
    const role = roleToAssign || inviteRole;
    
    if (!email) return;
    
    setIsInviting(true);
    try {
      await axios.post(
        `${API}/admin/invite`,
        { email, role },
        { withCredentials: true }
      );
      
      toast.success("Usuario autorizado", {
        description: `${email} ahora puede acceder con rol ${role}`
      });
      
      setInviteEmail("");
      setInviteRole("user");
      setShowInviteDialog(false);
      loadData();
    } catch (error) {
      toast.error("Error al invitar", {
        description: error.response?.data?.detail || "No se pudo autorizar al usuario"
      });
    } finally {
      setIsInviting(false);
    }
  };

  const handleRemoveEmail = async (email) => {
    if (!confirm(`¿Eliminar el acceso de ${email}?`)) return;
    
    try {
      await axios.delete(
        `${API}/admin/authorized-emails/${encodeURIComponent(email)}`,
        { withCredentials: true }
      );
      
      toast.success("Acceso eliminado", {
        description: `${email} ya no puede acceder`
      });
      
      loadData();
    } catch (error) {
      toast.error("Error al eliminar", {
        description: error.response?.data?.detail || "No se pudo eliminar el acceso"
      });
    }
  };

  const [resendingEmail, setResendingEmail] = React.useState(null);
  
  const handleResendInvitation = async (email) => {
    setResendingEmail(email);
    try {
      await axios.post(
        `${API}/admin/resend-invitation/${encodeURIComponent(email)}`,
        {},
        { withCredentials: true }
      );
      toast.success("Invitación enviada", {
        description: `Email de invitación reenviado a ${email}`
      });
    } catch (error) {
      toast.error("Error al enviar", {
        description: error.response?.data?.detail || "No se pudo enviar el email"
      });
    } finally {
      setResendingEmail(null);
    }
  };


  const handleLoadMoreLogs = async () => {
    setLoadingMoreLogs(true);
    try {
      const skip = activityLogs.length;
      const res = await axios.get(`${API}/admin/activity-logs?limit=50&skip=${skip}`, { withCredentials: true });
      const data = res.data;
      setActivityLogs(prev => [...prev, ...(data.logs || [])]);
      setActivityHasMore(data.has_more || false);
      setActivityTotal(data.total || 0);
    } catch (e) { console.error(e); }
    finally { setLoadingMoreLogs(false); }
  };


  const handleUpdateRole = async (userId, email, newRole) => {
    try {
      await axios.put(
        `${API}/admin/users/${userId}/role`,
        { role: newRole },
        { withCredentials: true }
      );
      
      toast.success("Rol actualizado", {
        description: `${email} ahora es ${newRole}`
      });
      
      loadData();
    } catch (error) {
      toast.error("Error al actualizar rol", {
        description: error.response?.data?.detail || "No se pudo actualizar el rol"
      });
    }
  };

  const handleToggleUserStatus = async (userId, email, currentStatus) => {
    const newStatus = currentStatus === "blocked" ? "active" : "blocked";
    const action = newStatus === "blocked" ? "bloquear" : "desbloquear";
    if (!confirm(`¿Seguro que deseas ${action} a ${email}?`)) return;
    try {
      await axios.put(`${API}/admin/users/${userId}/status`, { status: newStatus }, { withCredentials: true });
      toast.success(newStatus === "blocked" ? "Usuario bloqueado" : "Usuario desbloqueado");
      loadData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al actualizar status");
    }
  };

  const handleDeleteUser = async (userId, email) => {
    if (!confirm(`¿Seguro que deseas ELIMINAR permanentemente a ${email}? Esta acción no se puede deshacer.`)) return;
    try {
      await axios.delete(`${API}/admin/users/${userId}`, { withCredentials: true });
      toast.success(`Usuario ${email} eliminado`);
      loadData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al eliminar usuario");
    }
  };


  // Check if user email is already authorized
  const isEmailAuthorized = (email) => {
    return authorizedEmails.some(auth => auth.email.toLowerCase() === email.toLowerCase());
  };

  // Filtered data
  const filteredUsers = users.filter(user => {
    const matchesSearch = user.email.toLowerCase().includes(userSearch.toLowerCase()) ||
                         user.name.toLowerCase().includes(userSearch.toLowerCase());
    const matchesRole = userRoleFilter === "all" || user.role === userRoleFilter;
    return matchesSearch && matchesRole;
  });

  const filteredAuthorized = authorizedEmails.filter(auth => {
    const matchesSearch = auth.email.toLowerCase().includes(authSearch.toLowerCase());
    const matchesStatus = authStatusFilter === "all" || 
                         (authStatusFilter === "accepted" && auth.accepted) ||
                         (authStatusFilter === "pending" && !auth.accepted);
    return matchesSearch && matchesStatus;
  });

  const filteredAccess = accessHistory.filter(log => {
    const matchesSearch = log.user_email.toLowerCase().includes(accessSearch.toLowerCase());
    const matchesAction = accessActionFilter === "all" || log.action === accessActionFilter;
    return matchesSearch && matchesAction;
  });

  const filteredLogs = activityLogs.filter(log => {
    const matchesSearch = log.user_email.toLowerCase().includes(logSearch.toLowerCase()) ||
                         log.action.toLowerCase().includes(logSearch.toLowerCase());
    const matchesModule = logModuleFilter === "all" || log.module === logModuleFilter;
    const matchesAction = logActionFilter === "all" || log.action === logActionFilter;
    return matchesSearch && matchesModule && matchesAction;
  });

  // Get unique modules and actions for filters
  const uniqueModules = [...new Set(activityLogs.map(log => log.module))];
  const uniqueActions = [...new Set(activityLogs.map(log => log.action))];

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#e8eef3] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-purple-500 mx-auto mb-4" />
          <div className="text-slate-600">Cargando panel de administración...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#e8eef3]">
      {/* Header */}
      <div className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button variant="ghost" size="sm" onClick={onBack}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
              <div className="h-6 w-px bg-slate-200" />
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-500">
                  <Settings className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h1 className="text-lg font-bold text-slate-800">Panel de Administración</h1>
                  <p className="text-xs text-slate-500">Gestiona usuarios, permisos e integraciones</p>
                </div>
              </div>
            </div>
            <Button variant="outline" size="sm" onClick={loadData} className="gap-2">
              <RefreshCw className="h-4 w-4" />
              Actualizar
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex gap-8">
          {/* Sidebar */}
          <div className="w-64 flex-shrink-0">
            <div className="sticky top-24 space-y-6">
              {/* Overview Section */}
              <div>
                <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-4">
                  General
                </h3>
                <div className="space-y-1">
                  <SidebarItem
                    icon={BarChart3}
                    label="Dashboard"
                    active={activeSection === "overview" && activeTab === "dashboard"}
                    onClick={() => { setActiveSection("overview"); setActiveTab("dashboard"); }}
                  />
                </div>
              </div>

              {/* Users & Roles Section */}
              <div>
                <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-4">
                  Usuarios y Roles
                </h3>
                <div className="space-y-1">
                  <SidebarItem
                    icon={Users}
                    label="Usuarios"
                    badge={stats?.total_users}
                    active={activeSection === "users" && activeTab === "users"}
                    onClick={() => { setActiveSection("users"); setActiveTab("users"); }}
                  />
                  <SidebarItem
                    icon={Mail}
                    label="Autorizados"
                    badge={stats?.total_authorized}
                    active={activeSection === "users" && activeTab === "authorized"}
                    onClick={() => { setActiveSection("users"); setActiveTab("authorized"); }}
                  />
                  <SidebarItem
                    icon={Clock}
                    label="Accesos"
                    active={activeSection === "users" && activeTab === "access"}
                    onClick={() => { setActiveSection("users"); setActiveTab("access"); }}
                  />
                  <SidebarItem
                    icon={Activity}
                    label="Actividad"
                    badge={stats?.recent_activity_24h > 0 ? stats.recent_activity_24h : null}
                    active={activeSection === "users" && activeTab === "activity"}
                    onClick={() => { setActiveSection("users"); setActiveTab("activity"); }}
                  />
                </div>
              </div>

              {/* Integrations Section */}
              <div>
                <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-4">
                  Integraciones
                </h3>
                <div className="space-y-1">
                  <SidebarItem
                    icon={Database}
                    label="Databricks"
                    active={activeSection === "integrations" && activeTab === "databricks"}
                    onClick={() => { setActiveSection("integrations"); setActiveTab("databricks"); }}
                  />
                  <SidebarItem
                    icon={Activity}
                    label="Fivetran"
                    active={activeSection === "integrations" && activeTab === "fivetran"}
                    onClick={() => { setActiveSection("integrations"); setActiveTab("fivetran"); }}
                    disabled={!systemConfig.fivetran_enabled}
                    disabledIcon={Lock}
                  />
                  <SidebarItem
                    icon={Mail}
                    label="SMTP (Emails)"
                    active={activeSection === "integrations" && activeTab === "smtp"}
                    onClick={() => { setActiveSection("integrations"); setActiveTab("smtp"); }}
                  />
                  <SidebarItem
                    icon={Settings}
                    label="Claude (IA)"
                    active={activeSection === "integrations" && activeTab === "anthropic"}
                    onClick={() => { setActiveSection("integrations"); setActiveTab("anthropic"); }}
                  />
                </div>
              </div>

              {/* System Section */}
              <div>
                <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-4">
                  Sistema
                </h3>
                <div className="space-y-1">
                  <SidebarItem
                    icon={ToggleLeft}
                    label="Control de Módulos"
                    active={activeSection === "system" && activeTab === "modules"}
                    onClick={() => { setActiveSection("system"); setActiveTab("modules"); }}
                  />
                  <SidebarItem
                    icon={Activity}
                    label="Anomalías v2"
                    active={activeSection === "system" && activeTab === "anomaly-v2"}
                    onClick={() => { setActiveSection("system"); setActiveTab("anomaly-v2"); }}
                  />
                  <SidebarItem
                    icon={BarChart3}
                    label="Percentiles v2"
                    active={activeSection === "system" && activeTab === "percentile-v2"}
                    onClick={() => { setActiveSection("system"); setActiveTab("percentile-v2"); }}
                  />
                  <SidebarItem
                    icon={Activity}
                    label="DataPulse"
                    active={activeSection === "system" && activeTab === "datapulse"}
                    onClick={() => { setActiveSection("system"); setActiveTab("datapulse"); }}
                  />
                </div>
              </div>

              {/* Stats Summary */}
              {stats && (
                <div className="bg-white rounded-xl border p-4 space-y-3">
                  <h4 className="text-sm font-semibold text-slate-700">Resumen</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-slate-500">Usuarios activos</span>
                      <span className="font-medium">{stats.total_users}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-500">Admins</span>
                      <span className="font-medium">{stats.admin_count}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-500">Pendientes</span>
                      <span className="font-medium text-amber-600">{stats.pending_invites}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-500">Actividad 24h</span>
                      <span className="font-medium text-emerald-600">{stats.recent_activity_24h}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 min-w-0">
            {/* OVERVIEW SECTION */}
            {activeSection === "overview" && activeTab === "dashboard" && (
              <AdminDashboardAnalytics />
            )}

            {/* USERS SECTION */}
            {activeSection === "users" && (
              <>
                {/* Users Tab */}
                {activeTab === "users" && (
                  <Card>
                    <CardHeader>
                      <div className="flex items-center justify-between">
                        <div>
                          <CardTitle className="text-xl flex items-center gap-2">
                            <Users className="h-5 w-5 text-purple-500" />
                            Usuarios Registrados
                          </CardTitle>
                          <CardDescription>
                            Usuarios que han iniciado sesión al menos una vez
                          </CardDescription>
                        </div>
                        <Dialog open={showInviteDialog} onOpenChange={setShowInviteDialog}>
                          <DialogTrigger asChild>
                            <Button className="gap-2 bg-gradient-to-r from-purple-500 to-indigo-500">
                              <UserPlus className="h-4 w-4" />
                              Autorizar Usuario
                            </Button>
                          </DialogTrigger>
                          <DialogContent>
                            <DialogHeader>
                              <DialogTitle>Autorizar Nuevo Usuario</DialogTitle>
                              <DialogDescription>
                                Agrega un email a la lista de usuarios autorizados.
                              </DialogDescription>
                            </DialogHeader>
                            <div className="space-y-4 py-4">
                              <div className="space-y-2">
                                <Label>Email</Label>
                                <Input
                                  type="email"
                                  placeholder="usuario@dominio.com"
                                  value={inviteEmail}
                                  onChange={(e) => setInviteEmail(e.target.value)}
                                />
                                <p className="text-xs text-slate-500">
                                  Solo dominios: @latamdigitalmarketing.com, @endavantgroup.com, @perform-ly.com, @ldm.gg
                                </p>
                              </div>
                              <div className="space-y-2">
                                <Label>Rol</Label>
                                <Select value={inviteRole} onValueChange={setInviteRole}>
                                  <SelectTrigger>
                                    <SelectValue />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="user">Usuario</SelectItem>
                                    <SelectItem value="admin">Administrador</SelectItem>
                                  </SelectContent>
                                </Select>
                              </div>
                            </div>
                            <DialogFooter>
                              <Button variant="outline" onClick={() => setShowInviteDialog(false)}>
                                Cancelar
                              </Button>
                              <Button onClick={() => handleInvite()} disabled={isInviting || !inviteEmail.trim()}>
                                {isInviting ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                                Autorizar
                              </Button>
                            </DialogFooter>
                          </DialogContent>
                        </Dialog>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <FilterBar 
                        searchValue={userSearch} 
                        onSearchChange={setUserSearch}
                        placeholder="Buscar por nombre o email..."
                      >
                        <Select value={userRoleFilter} onValueChange={setUserRoleFilter}>
                          <SelectTrigger className="w-[140px] h-9 bg-white">
                            <SelectValue placeholder="Rol" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todos los roles</SelectItem>
                            <SelectItem value="admin">Admin</SelectItem>
                            <SelectItem value="user">Usuario</SelectItem>
                          </SelectContent>
                        </Select>
                      </FilterBar>

                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead className="w-[40%]">Usuario</TableHead>
                            <TableHead className="w-[10%]">Rol</TableHead>
                            <TableHead className="w-[18%]">Registrado</TableHead>
                            <TableHead className="w-[18%]">Último Acceso</TableHead>
                            <TableHead className="w-[14%] text-right">Acciones</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {filteredUsers.map((user) => {
                            const isBlocked = user.status === "blocked";
                            const isSelf = user.email === currentUser?.email;
                            return (
                            <TableRow key={user.user_id} className={isBlocked ? "opacity-60 bg-red-50/30" : ""}>
                              <TableCell>
                                <div className="flex items-center gap-3">
                                  {user.picture ? (
                                    <img src={user.picture} alt="" className={`h-8 w-8 rounded-full flex-shrink-0 ${isBlocked ? "grayscale" : ""}`} />
                                  ) : (
                                    <div className="h-8 w-8 rounded-full bg-slate-200 flex items-center justify-center flex-shrink-0">
                                      <UserIcon className="h-4 w-4 text-slate-500" />
                                    </div>
                                  )}
                                  <div className="min-w-0">
                                    <p className="font-medium text-sm text-slate-800 truncate">{user.name}</p>
                                    <p className="text-xs text-slate-400 truncate">{user.email}</p>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell>
                                <div className="flex items-center gap-1">
                                  <Badge className={`text-xs ${user.role === "admin" ? "bg-purple-100 text-purple-700" : "bg-slate-100 text-slate-700"}`}>
                                    {user.role === "admin" ? <Crown className="h-3 w-3 mr-1" /> : null}
                                    {user.role}
                                  </Badge>
                                  {isBlocked && <Badge className="text-[10px] bg-red-100 text-red-700">Bloqueado</Badge>}
                                </div>
                              </TableCell>
                              <TableCell className="text-xs text-slate-500 whitespace-nowrap">{formatDate(user.created_at)}</TableCell>
                              <TableCell className="text-xs text-slate-500 whitespace-nowrap">{formatDate(user.last_login)}</TableCell>
                              <TableCell className="text-right">
                                <div className="flex items-center justify-end gap-1">
                                  {!isSelf && currentUser?.role === "admin" && (
                                    <DropdownMenu>
                                      <DropdownMenuTrigger asChild>
                                        <Button variant="ghost" size="sm" className="h-7 w-7 p-0">
                                          <MoreHorizontal className="h-4 w-4 text-slate-500" />
                                        </Button>
                                      </DropdownMenuTrigger>
                                      <DropdownMenuContent align="end" className="w-48">
                                        <DropdownMenuItem onClick={() => handleUpdateRole(user.user_id, user.email, user.role === "admin" ? "user" : "admin")}>
                                          <Crown className="h-3.5 w-3.5 mr-2" />
                                          {user.role === "admin" ? "Cambiar a Usuario" : "Cambiar a Admin"}
                                        </DropdownMenuItem>
                                        <DropdownMenuSeparator />
                                        <DropdownMenuItem onClick={() => handleToggleUserStatus(user.user_id, user.email, user.status)}>
                                          {isBlocked
                                            ? <><ShieldCheck className="h-3.5 w-3.5 mr-2 text-emerald-600" />Desbloquear</>
                                            : <><Ban className="h-3.5 w-3.5 mr-2 text-amber-600" />Bloquear</>
                                          }
                                        </DropdownMenuItem>
                                        <DropdownMenuSeparator />
                                        <DropdownMenuItem className="text-red-600 focus:text-red-600" onClick={() => handleDeleteUser(user.user_id, user.email)}>
                                          <Trash2Icon className="h-3.5 w-3.5 mr-2" />Eliminar
                                        </DropdownMenuItem>
                                      </DropdownMenuContent>
                                    </DropdownMenu>
                                  )}
                                  {!isSelf && !isEmailAuthorized(user.email) && (
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={() => handleInvite(user.email, user.role)}
                                      disabled={isInviting}
                                      className="h-7 text-xs px-2"
                                    >
                                      <UserPlus className="h-3 w-3 mr-1" />
                                      Autorizar
                                    </Button>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                            );
                          })}
                          {filteredUsers.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={5} className="text-center text-slate-500 py-8">
                                No se encontraron usuarios
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <div className="mt-4 text-xs text-slate-500">
                        Mostrando {filteredUsers.length} de {users.length} usuarios
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Authorized Emails Tab */}
                {activeTab === "authorized" && (
                  <Card>
                    <CardHeader>
                      <div className="flex items-center justify-between">
                        <div>
                          <CardTitle className="text-xl flex items-center gap-2">
                            <Mail className="h-5 w-5 text-blue-500" />
                            Emails Autorizados
                          </CardTitle>
                          <CardDescription>
                            Lista de emails que pueden acceder a la plataforma
                          </CardDescription>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <FilterBar 
                        searchValue={authSearch} 
                        onSearchChange={setAuthSearch}
                        placeholder="Buscar por email..."
                      >
                        <Select value={authStatusFilter} onValueChange={setAuthStatusFilter}>
                          <SelectTrigger className="w-[140px] h-9 bg-white">
                            <SelectValue placeholder="Estado" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todos</SelectItem>
                            <SelectItem value="accepted">Activos</SelectItem>
                            <SelectItem value="pending">Pendientes</SelectItem>
                          </SelectContent>
                        </Select>
                      </FilterBar>

                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead className="w-[45%]">Email</TableHead>
                            <TableHead className="w-[10%]">Rol</TableHead>
                            <TableHead className="w-[12%]">Estado</TableHead>
                            <TableHead className="w-[18%]">Fecha</TableHead>
                            <TableHead className="w-[15%] text-right">Acciones</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {filteredAuthorized.map((auth) => (
                            <TableRow key={auth.id}>
                              <TableCell>
                                <div>
                                  <p className="font-medium text-sm text-slate-800">{auth.email}</p>
                                  <p className="text-xs text-slate-400 mt-0.5">
                                    Invitado por {auth.invited_by?.split("@")[0] || "sistema"}
                                  </p>
                                </div>
                              </TableCell>
                              <TableCell>
                                <Badge className={`text-xs ${auth.role === "admin" ? "bg-purple-100 text-purple-700" : "bg-slate-100 text-slate-700"}`}>
                                  {auth.role}
                                </Badge>
                              </TableCell>
                              <TableCell>
                                {auth.accepted ? (
                                  <Badge className="bg-emerald-100 text-emerald-700 gap-1 text-xs">
                                    <CheckCircle className="h-3 w-3" />
                                    Activo
                                  </Badge>
                                ) : (
                                  <Badge className="bg-amber-100 text-amber-700 gap-1 text-xs">
                                    <Clock className="h-3 w-3" />
                                    Pendiente
                                  </Badge>
                                )}
                              </TableCell>
                              <TableCell className="text-xs text-slate-500 whitespace-nowrap">
                                {formatDate(auth.invited_at)}
                              </TableCell>
                              <TableCell className="text-right">
                                <div className="flex items-center justify-end gap-1">
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    className="text-indigo-500 hover:text-indigo-700 hover:bg-indigo-50 h-8 w-8 p-0"
                                    onClick={() => handleResendInvitation(auth.email)}
                                    disabled={resendingEmail === auth.email}
                                    title="Reenviar invitación"
                                    data-testid={`resend-btn-${auth.email}`}
                                  >
                                    {resendingEmail === auth.email ? (
                                      <Loader2 className="h-4 w-4 animate-spin" />
                                    ) : (
                                      <Send className="h-4 w-4" />
                                    )}
                                  </Button>
                                  {auth.email !== currentUser?.email && auth.invited_by !== "system" && (
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 w-8 p-0"
                                      onClick={() => handleRemoveEmail(auth.email)}
                                    >
                                      <Trash2 className="h-4 w-4" />
                                    </Button>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                          {filteredAuthorized.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={5} className="text-center text-slate-500 py-8">
                                No se encontraron emails autorizados
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <div className="mt-4 text-xs text-slate-500">
                        Mostrando {filteredAuthorized.length} de {authorizedEmails.length} emails
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Access History Tab */}
                {activeTab === "access" && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="text-xl flex items-center gap-2">
                        <Clock className="h-5 w-5 text-amber-500" />
                        Historial de Accesos
                      </CardTitle>
                      <CardDescription>
                        Registro de inicios y cierres de sesión
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <FilterBar 
                        searchValue={accessSearch} 
                        onSearchChange={setAccessSearch}
                        placeholder="Buscar por email..."
                      >
                        <Select value={accessActionFilter} onValueChange={setAccessActionFilter}>
                          <SelectTrigger className="w-[160px] h-9 bg-white">
                            <SelectValue placeholder="Acción" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todas las acciones</SelectItem>
                            <SelectItem value="login">Inicios de sesión</SelectItem>
                            <SelectItem value="logout">Cierres de sesión</SelectItem>
                          </SelectContent>
                        </Select>
                      </FilterBar>

                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Acción</TableHead>
                            <TableHead>Usuario</TableHead>
                            <TableHead>Email</TableHead>
                            <TableHead>IP</TableHead>
                            <TableHead>Fecha</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {filteredAccess.map((log) => (
                            <TableRow key={log.id}>
                              <TableCell>
                                <Badge className={log.action === "login" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-700"}>
                                  {getActionIcon(log.action)} {log.action === "login" ? "Inicio de sesión" : "Cierre de sesión"}
                                </Badge>
                              </TableCell>
                              <TableCell className="font-medium">{log.user_email.split("@")[0]}</TableCell>
                              <TableCell className="text-sm text-slate-500">{log.user_email}</TableCell>
                              <TableCell className="text-sm text-slate-500 font-mono">{log.ip_address || "-"}</TableCell>
                              <TableCell className="text-sm text-slate-500">{formatDate(log.timestamp)}</TableCell>
                            </TableRow>
                          ))}
                          {filteredAccess.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={5} className="text-center text-slate-500 py-8">
                                No hay historial de accesos
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <div className="mt-4 text-xs text-slate-500">
                        Mostrando {filteredAccess.length} de {accessHistory.length} registros
                      </div>
                    </CardContent>
                  </Card>
                )}

                {/* Activity Logs Tab */}
                {activeTab === "activity" && (
                  <Card>
                    <CardHeader>
                      <CardTitle className="text-xl flex items-center gap-2">
                        <Activity className="h-5 w-5 text-emerald-500" />
                        Logs de Actividad
                      </CardTitle>
                      <CardDescription>
                        Registro de todas las acciones realizadas en la plataforma. Haz clic en una fila para ver más detalles.
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <FilterBar 
                        searchValue={logSearch} 
                        onSearchChange={setLogSearch}
                        placeholder="Buscar por email o acción..."
                      >
                        <Select value={logModuleFilter} onValueChange={setLogModuleFilter}>
                          <SelectTrigger className="w-[180px] h-9 bg-white">
                            <SelectValue placeholder="Módulo" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todos los módulos</SelectItem>
                            {uniqueModules.map(module => (
                              <SelectItem key={module} value={module}>
                                {getModuleLabel(module)}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                        <Select value={logActionFilter} onValueChange={setLogActionFilter}>
                          <SelectTrigger className="w-[180px] h-9 bg-white">
                            <SelectValue placeholder="Acción" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todas las acciones</SelectItem>
                            {uniqueActions.map(action => (
                              <SelectItem key={action} value={action}>
                                {getActionIcon(action)} {getActionLabel(action)}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </FilterBar>

                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead className="w-[30%]">Acción</TableHead>
                            <TableHead className="w-[25%]">Usuario</TableHead>
                            <TableHead className="w-[25%]">Detalles</TableHead>
                            <TableHead className="w-[15%]">Fecha</TableHead>
                            <TableHead className="w-[5%]"></TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {filteredLogs.map((log) => (
                            <TableRow 
                              key={log.id} 
                              className="cursor-pointer hover:bg-slate-50"
                              onClick={() => {
                                setSelectedLog(log);
                                setShowLogDetail(true);
                              }}
                            >
                              <TableCell>
                                <div className="flex items-center gap-2">
                                  <span className="text-base flex-shrink-0">{getActionIcon(log.action)}</span>
                                  <div className="min-w-0">
                                    <p className="font-medium text-sm capitalize truncate">{getActionLabel(log.action)}</p>
                                    <Badge className={`text-[10px] ${getModuleColor(log.module)}`}>
                                      {getModuleLabel(log.module)}
                                    </Badge>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className="text-sm text-slate-600 truncate max-w-0">
                                {log.user_email}
                              </TableCell>
                              <TableCell className="text-xs text-slate-400 max-w-0 truncate">
                                {getAutoDescription(log)}
                              </TableCell>
                              <TableCell className="text-xs text-slate-500 whitespace-nowrap">{formatDate(log.timestamp)}</TableCell>
                              <TableCell>
                                <Eye className="h-4 w-4 text-slate-300" />
                              </TableCell>
                            </TableRow>
                          ))}
                          {filteredLogs.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={5} className="text-center text-slate-500 py-8">
                                No hay logs de actividad
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <div className="mt-4 flex items-center justify-between">
                        <span className="text-xs text-slate-500">
                          Mostrando {filteredLogs.length} de {activityTotal} registros
                        </span>
                        {activityHasMore && (
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={handleLoadMoreLogs}
                            disabled={loadingMoreLogs}
                            className="text-xs"
                          >
                            {loadingMoreLogs ? (
                              <><Loader2 className="h-3 w-3 mr-1 animate-spin" />Cargando...</>
                            ) : (
                              <>Cargar más</>
                            )}
                          </Button>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                )}
              </>
            )}

            {/* INTEGRATIONS SECTION */}
            {activeSection === "integrations" && (
              <>
                {activeTab === "databricks" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <Database className="h-6 w-6 text-purple-500" />
                        Conexiones de Datos
                      </h2>
                      <p className="text-slate-500 mt-1">
                        Gestiona las conexiones a Databricks Lakebase y Lakehouse
                      </p>
                    </div>
                    
                    <Tabs defaultValue="lakebase" className="w-full">
                      <TabsList className="grid w-full grid-cols-2 mb-6">
                        <TabsTrigger value="lakebase" className="flex items-center gap-2">
                          <Database className="h-4 w-4" />
                          Lakebase (PostgreSQL)
                        </TabsTrigger>
                        <TabsTrigger value="lakehouse" className="flex items-center gap-2">
                          <Database className="h-4 w-4" />
                          Lakehouse (Databricks)
                        </TabsTrigger>
                      </TabsList>
                      
                      <TabsContent value="lakebase">
                        <Card>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                              <div className="p-2 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-600">
                                <Database className="h-4 w-4 text-white" />
                              </div>
                              Lakebase (PostgreSQL)
                            </CardTitle>
                            <CardDescription>
                              Conexión PostgreSQL optimizada para consultas del módulo Workload Analysis. 
                              Recomendada por eficiencia y menor costo.
                            </CardDescription>
                          </CardHeader>
                          <CardContent>
                            <LakebaseSettings />
                          </CardContent>
                        </Card>
                      </TabsContent>
                      
                      <TabsContent value="lakehouse">
                        <Card>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                              <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600">
                                <Database className="h-4 w-4 text-white" />
                              </div>
                              Lakehouse (Databricks)
                            </CardTitle>
                            <CardDescription>
                              Conexión completa a Databricks Lakehouse. Usada como fallback si Lakebase no está disponible.
                              <span className="text-amber-600 font-medium"> ⚠️ Mayor costo por consulta.</span>
                            </CardDescription>
                          </CardHeader>
                          <CardContent>
                            <DatabricksSettings />
                          </CardContent>
                        </Card>
                      </TabsContent>
                    </Tabs>
                  </div>
                )}
                
                {activeTab === "fivetran" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <Activity className="h-6 w-6 text-emerald-500" />
                        Estado de Fivetran
                      </h2>
                      <p className="text-slate-500 mt-1">
                        Monitoreo de conectores de datos (auto-configurado via Databricks)
                      </p>
                    </div>
                    <div className="max-w-2xl">
                      <FivetranStatusCard />
                    </div>
                  </div>
                )}

                {activeTab === "smtp" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <Mail className="h-6 w-6 text-indigo-500" />
                        Configuración SMTP
                      </h2>
                      <p className="text-slate-500 mt-1">
                        Configura el servidor de correo para notificaciones y alertas del sistema
                      </p>
                    </div>
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <div className="p-2 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600">
                            <Mail className="h-4 w-4 text-white" />
                          </div>
                          SMTP (Emails)
                        </CardTitle>
                        <CardDescription>
                          Configura tu servidor SMTP para habilitar el envío de correos electrónicos. 
                          Compatible con Brevo, SendGrid, Gmail y cualquier proveedor SMTP.
                        </CardDescription>
                      </CardHeader>
                      <CardContent>
                        <SmtpSettings />
                      </CardContent>
                    </Card>
                  </div>
                )}

                {activeTab === "anthropic" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <Settings className="h-6 w-6 text-violet-500" />
                        Claude (Anthropic) API
                      </h2>
                      <p className="text-slate-500 mt-1">
                        API key para funcionalidades de IA (Media Planner, análisis de briefs)
                      </p>
                    </div>
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <div className="p-2 rounded-lg bg-gradient-to-br from-violet-500 to-purple-600">
                            <Settings className="h-4 w-4 text-white" />
                          </div>
                          Anthropic API Key
                        </CardTitle>
                        <CardDescription>
                          Configura la API key de Anthropic (Claude) para que los módulos de IA funcionen sin que los usuarios necesiten su propia key.
                        </CardDescription>
                      </CardHeader>
                      <CardContent>
                        <AnthropicSettings />
                      </CardContent>
                    </Card>
                  </div>
                )}
              </>
            )}

            {/* SYSTEM SECTION */}
            {activeSection === "system" && (
              <>
                {activeTab === "modules" && (
                  <div className="max-w-2xl">
                    <ModuleControl />
                  </div>
                )}
                {activeTab === "anomaly-v2" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <Activity className="h-6 w-6 text-indigo-500" />
                        Anomaly Detection v2 - Baseline
                      </h2>
                      <p className="text-slate-500 mt-1">
                        Gestión del cálculo de baseline estadístico para detección de anomalías con umbrales adaptativos
                      </p>
                    </div>
                    <AnomalyV2Admin />
                  </div>
                )}
                {activeTab === "percentile-v2" && (
                  <div>
                    <div className="mb-6">
                      <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                        <BarChart3 className="h-6 w-6 text-cyan-500" />
                        Percentile Analysis v2 - Baseline
                      </h2>
                      <p className="text-slate-500 mt-1">
                        Gestión del cálculo de percentiles históricos y análisis diario
                      </p>
                    </div>
                    <PercentileV2Admin />
                  </div>
                )}
                {activeTab === "datapulse" && (
                  <DataPulseAdmin isAdmin={currentUser?.role === "admin"} />
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Activity Log Detail Modal */}
      <ActivityLogDetailModal 
        log={selectedLog} 
        open={showLogDetail} 
        onClose={setShowLogDetail} 
      />
    </div>
  );
};
